/**
 * @generated SignedSource<<4a70ec31625e61c2d65ebcde084e9cc7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TopNavigation_slotsQuery$data = {
  readonly helpButton?: {
    readonly " $fragmentSpreads": FragmentRefs<"HelpButton_query">;
  } | null;
  readonly notifications?: {
    readonly " $fragmentSpreads": FragmentRefs<"Nav4NotificationsData">;
  } | null;
  readonly profile?: {
    readonly " $fragmentSpreads": FragmentRefs<"ProfileNew">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"EditionAwareness_query" | "ProductHomeWithQuery" | "SettingsAction_query">;
  readonly " $fragmentType": "TopNavigation_slotsQuery";
};
export type TopNavigation_slotsQuery$key = {
  readonly " $data"?: TopNavigation_slotsQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopNavigation_slotsQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "collabContextRoutingAri"
    },
    {
      "kind": "RootArgument",
      "name": "isAnonymous"
    },
    {
      "kind": "RootArgument",
      "name": "skipHelpButtonRelayRead"
    }
  ],
  "kind": "Fragment",
  "name": "TopNavigation_slotsQuery",
  "selections": [
    {
      "condition": "isAnonymous",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "fragment": {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ProfileNew"
              }
            ],
            "type": "Query"
          },
          "kind": "AliasedInlineFragmentSpread",
          "name": "profile"
        },
        {
          "fragment": {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "collabContextRoutingAri",
                    "variableName": "collabContextRoutingAri"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "Nav4NotificationsData"
              }
            ],
            "type": "Query"
          },
          "kind": "AliasedInlineFragmentSpread",
          "name": "notifications"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ProductHomeWithQuery"
    },
    {
      "kind": "FragmentSpread",
      "name": "EditionAwareness_query"
    },
    {
      "kind": "FragmentSpread",
      "name": "SettingsAction_query"
    },
    {
      "condition": "skipHelpButtonRelayRead",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "fragment": {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "HelpButton_query"
              }
            ],
            "type": "Query"
          },
          "kind": "AliasedInlineFragmentSpread",
          "name": "helpButton"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "fe64e0fcdeb71c991aaab797012d669b";

export default node;
